module.exports = __webpack_public_path__ + "static/media/Icon_PGD_Opacity70.39dfa673.png";